import React from 'react';
import './Terms.css'; // Reuse same styling

const Contact = () => (
  <div className="legalWrapper">
    <h1>Contact Us</h1>

    <h2>Phone</h2>
    <p>(718)-502-5271</p>

    <h2>Email</h2>
    <p>
      <a href="mailto:newupt@yahoo.com">newupt@yahoo.com</a>
    </p>
  </div>
);

export default Contact;
